export default __webpack_public_path__ + "static/media/mustard.2b93b468.png";